enum Token {
    access = 'accessToken',
    refresh = 'refreshToken',
    otp = 'otpToken',
}

export default Token;
